import { PiggyBank } from 'lucide-react';
import type { Goal } from '@app/shared';
import type { WebModule } from '../../app/types.ts';
import { familyRecords, scoreText } from '../../platform/search.ts';

export const goalsModule: WebModule = {
  id: 'goals',
  label: 'Goals',
  icon: PiggyBank,
  path: '/goals',
  nav: { group: 'household', order: 40 },
  routes: [
    { path: 'goals', lazy: async () => ({ Component: (await import('./GoalsScreens.tsx')).GoalsScreen }) },
    { path: 'goals/:goalId', lazy: async () => ({ Component: (await import('./GoalsScreens.tsx')).GoalScreen }) },
  ],
  async search(q, ctx) {
    const goals = await familyRecords<Goal>('goals', ctx.familyId);
    return goals
      .map((g) => ({ g, score: scoreText(q, [g.title, g.notes]) }))
      .filter((x) => x.score > 0)
      .map(({ g, score }) => ({
        key: `goals:${g.id}`,
        title: g.title,
        subtitle: g.kind === 'budget' ? 'Budget' : 'Goal',
        to: `/goals/${g.id}`,
        group: 'Goals',
        icon: PiggyBank,
        score,
      }));
  },
};
